// @ts-nocheck
import React from 'react';
import { sx } from '../sx';
import { NOTE, SEGMENT, SEGMENTS, SELECT, SPLIT, pill } from '../controls';
import CohortRuleFields from './CohortRuleFields';

function Segments({ items }) {
  return (
    <div style={sx(SEGMENTS)}>
      {(items || []).map((s, i) => (
        <button key={i} type="button" aria-pressed={s.selected === undefined ? undefined : !!s.selected} onClick={s.onClick} style={sx(`${SEGMENT};box-shadow:${s.selected ? 'none' : s.divider || 'none'};background:${s.bg};color:${s.fg};font-weight:${s.fw || 400}`)}>
          {s.label}
        </button>
      ))}
    </div>
  );
}

function MonthSelect({ value, onChange, options }) {
  return (
    <select value={value} onChange={onChange} style={sx(SELECT)}>
      {(options || []).map((o, i) => (
        <option key={i} value={o.value}>{o.label}</option>
      ))}
    </select>
  );
}

export default function CohortToolbar({ vm }: { vm: any }) {
  return (
    <div style={sx(`flex:none;display:flex;align-items:center;flex-wrap:wrap;gap:10px 12px;padding:11px 20px;border-bottom:1px solid #DCE4F2`)}>
      <Segments items={vm.blockToggle} />
      <div style={sx(SPLIT)}></div>
      <Segments items={vm.viewToggle} />
      {vm.cohortRule ? (
        <>
          <div style={sx(SPLIT)}></div>
          <div data-testid="cohort-forecast-method" title={vm.cohortRule.summary} style={sx(`flex:none;display:flex;align-items:center;gap:6px`)}>
            <span style={sx(`flex:none;font-size:12px;color:var(--ink-4)`)}>Forecast</span>
            <CohortRuleFields f={vm.cohortRule} />
          </div>
        </>
      ) : null}
      <div style={sx(SPLIT)}></div>
      <div style={sx(`flex:none;display:flex;align-items:center;gap:6px`)}>
        <MonthSelect value={vm.customFrom} onChange={vm.onCustomFrom} options={vm.monthOpts} />
        <span style={sx(`flex:none;font-size:12px;color:var(--ink-4)`)}>to</span>
        <MonthSelect value={vm.customTo} onChange={vm.onCustomTo} options={vm.monthOpts} />
      </div>
      <Segments items={vm.grans} />
      <select value={vm.cmpVersion} onChange={vm.onCmpVersion} style={sx(`${SELECT};max-width:190px`)}>
        {(vm.cmpOpts || []).map((o, i) => (
          <option key={i} value={o.value}>{o.label}</option>
        ))}
      </select>
      {vm.cmpActuals ? <div style={sx(`${NOTE};background:#EDF1F8`)}>{vm.cmpActualsNote}</div> : null}
      {vm.showNewScenario ? (
        <button className="gmHover" onClick={vm.startScenario} style={sx(`${pill()};color:#0060a8`)} data-hover="border-color:#00B3FF">＋ New scenario</button>
      ) : null}
      {vm.cmpOn ? (
        <div style={sx(`flex:none;display:flex;gap:6px`)}>
          {(vm.cmpModes || []).map((m, i) => (
            <button key={i} type="button" onClick={m.onClick} style={sx(`${pill(m.border)};background:${m.bg};color:${m.fg}`)}>{m.label}</button>
          ))}
        </div>
      ) : null}
      <div style={sx(`flex:1;min-width:40px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:12px;color:var(--ink-3)`)}>{vm.cohortNote}</div>
    </div>
  );
}
